import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import * as traclink from '@webapp/sdk/traclink';

import { concatMap, mergeMap, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '@webapp/store/state';
import {
  PublishTracPageDraft,
  PublishTracPageDraftSuccess,
  UpdateTracPage,
} from '../action-creators';
import { PUBLISH_TRAC_PAGE_DRAFT } from '../actions';
import {
  AddTourEventSuccess,
  ResetEventDrafts,
  UpdateTourEventSuccess,
} from '@webapp/store/traclink/action-creators';
import { NoOp } from '@webapp/store/ui/action-creators';

export const publishDraftEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, PublishTracPageDraft>(PUBLISH_TRAC_PAGE_DRAFT),
    withLatestFrom(state$),
    mergeMap(async ([_, state]) => {
      const pageDraft = state.tracpage.artistPageDraft;
      const eventDrafts = state.traclink.tourEventDrafts;

      const eventsToCreate = eventDrafts.new;
      const eventsToUpdate = Object.values(eventDrafts.edit);

      const artistId = state.activeProfile.id;

      try {
        if (!artistId) throw new Error('No artist id');

        const createEventPromises = eventsToCreate.map((e) =>
          traclink
            .createTourEvent({
              ...e,
              ownerId: artistId,
            })
            .then((tour) => ({
              idMapEntry: [e.id, tour.id] as [string, string],
              created: tour,
            }))
        );
        const updateEventPromises = eventsToUpdate.map((e) =>
          traclink.updateTourEvent(e)
        );

        const createEventResults = await Promise.all(createEventPromises);
        const updateEventResults = await Promise.all(updateEventPromises);

        // draft mock id -> created id
        const createdEventIdsMap = Object.fromEntries(
          createEventResults.map((r) => r.idMapEntry)
        );

        if (pageDraft.itemsConfig) {
          const eventsConfigEntries = Object.entries(
            pageDraft.itemsConfig.events
          );
          const configWithUpdatedIds = Object.fromEntries(
            eventsConfigEntries.map(([eventId, config]) => [
              createdEventIdsMap[eventId] ?? eventId,
              config,
            ])
          );

          pageDraft.itemsConfig.events = configWithUpdatedIds;
        }

        if (pageDraft.featuredItem) {
          const newFeaturedEventId =
            createdEventIdsMap[pageDraft.featuredItem.id] || null;
          if (newFeaturedEventId) {
            pageDraft.featuredItem = {
              ...pageDraft.featuredItem,
              id: newFeaturedEventId,
            };
          }
        }

        const actions = [
          ...createEventResults.map((r) => new AddTourEventSuccess(r.created)),
          ...updateEventResults.map((r) => new UpdateTourEventSuccess(r)),
          new UpdateTracPage('tracpage', pageDraft),

          new ResetEventDrafts(),
          new PublishTracPageDraftSuccess(),
        ];

        return actions;
      } catch (e) {
        console.error('publishDraftEpic error:', e);
        return [new NoOp()];
      }
    }),
    concatMap((actions) => actions)
  );
